// extracted by mini-css-extract-plugin
export default {"burger":"burger-icon_burger__3cZcz","line1":"burger-icon_line1__pT+Cg","line2":"burger-icon_line2__LPQPt","line3":"burger-icon_line3__R00eU","opened":"burger-icon_opened__pX82j"};